module.exports = __webpack_public_path__ + "img/search-bar.7bbe5179.svg";